export default {
  basePath: window["VUE_APP_API_URL"] + "/api/merchant",
  perPage: 25,
  perPageOptions: [25, 50, 100],
};
